function initCollectionGridSections() {
  const sections = document.querySelectorAll("[data-collection-grid-section]");
  if (!sections.length) return;

  sections.forEach((section) => {
    if (section.dataset.initialized === "true") return;
    section.dataset.initialized = "true";
    new CollectionGridSection(section);
  });
}

class CollectionGridSection {
  constructor(root) {
    this.root = root;
    this.defaultSort = root.dataset.defaultSort || "";
    this.bind();
  }

  bind() {
    this.overlay = this.root.querySelector("[data-collection-overlay]");
    this.filters = this.root.querySelector("[data-collection-filters]");
    this.openButtons = Array.from(this.root.querySelectorAll("[data-collection-open-filters]"));
    this.closeButton = this.root.querySelector("[data-collection-close-filters]");
    this.resetButton = this.root.querySelector("[data-collection-reset]");
    this.clearInlineButton = this.root.querySelector("[data-collection-clear-inline]");
    this.form = this.root.querySelector("[data-collection-filters-form]");
    this.actions = this.root.querySelector("[data-collection-actions]");
    this.stickyActions = this.root.querySelector("[data-collection-sticky-actions]");

    this.openButtons.forEach((button) => {
      button.addEventListener("click", () => this.openFilters());
    });

    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => this.closeFilters());
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", () => this.closeFilters());
    }

    if (this.resetButton) {
      this.resetButton.addEventListener("click", () => this.resetFilters());
    }

    if (this.clearInlineButton) {
      this.clearInlineButton.addEventListener("click", () => {
        window.location.href = window.location.pathname;
      });
    }

    this.bindStickyActions();
  }

  openFilters() {
    if (!this.filters || !this.overlay) return;
    this.filters.hidden = false;
    this.overlay.hidden = false;
    this.root.classList.add("is-filters-open");
    document.body.classList.add("is-collection-filters-open");
  }

  closeFilters() {
    if (!this.filters || !this.overlay) return;
    this.root.classList.remove("is-filters-open");
    document.body.classList.remove("is-collection-filters-open");
    this.filters.hidden = true;
    this.overlay.hidden = true;
  }

  resetFilters() {
    if (!this.form) return;

    this.form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.checked = false;
    });

    const sortInputs = Array.from(this.form.querySelectorAll('input[name="sort_by"]'));
    if (!sortInputs.length) return;

    let matchedDefault = false;
    sortInputs.forEach((input, index) => {
      const shouldCheck = this.defaultSort
        ? input.value === this.defaultSort
        : index === 0;
      input.checked = shouldCheck;
      if (shouldCheck) matchedDefault = true;
    });

    if (!matchedDefault) {
      sortInputs[0].checked = true;
    }
  }

  bindStickyActions() {
    if (!this.actions || !this.stickyActions || !window.matchMedia) return;

    this.mobileMedia = window.matchMedia("(max-width: 767px)");
    this.handleStickyObserver = () => this.setupStickyObserver();

    if (typeof this.mobileMedia.addEventListener === "function") {
      this.mobileMedia.addEventListener("change", this.handleStickyObserver);
    } else if (typeof this.mobileMedia.addListener === "function") {
      this.mobileMedia.addListener(this.handleStickyObserver);
    }

    this.setupStickyObserver();
  }

  setupStickyObserver() {
    if (this.actionsObserver) {
      this.actionsObserver.disconnect();
      this.actionsObserver = null;
    }

    this.hideStickyActions();

    if (!this.mobileMedia?.matches || !("IntersectionObserver" in window)) return;

    this.actionsObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.hideStickyActions();
          return;
        }

        this.showStickyActions();
      },
      {
        threshold: 0,
      }
    );

    this.actionsObserver.observe(this.actions);
  }

  showStickyActions() {
    if (!this.stickyActions) return;
    this.stickyActions.hidden = false;
    this.root.classList.add("has-sticky-actions");
  }

  hideStickyActions() {
    if (!this.stickyActions) return;
    this.stickyActions.hidden = true;
    this.root.classList.remove("has-sticky-actions");
  }
}

initCollectionGridSections();
